import CloseIcon from "@mui/icons-material/Close";
import { Modal, Box, Typography, Button } from "@mui/material";
import { useSelector } from "react-redux";
import { courseCompletionModalSx } from './styles'

const CourseCompletionModal = ({ handleClose }) => {
  const isOpenModal = useSelector((state) => state.auth.isOpenModal)
  return (
    <Modal open={isOpenModal} onClose={handleClose} disableScrollLock>
      <Box sx={courseCompletionModalSx.modalBox}>
        <Box onClick={handleClose} sx={courseCompletionModalSx.closeBox}>
          <CloseIcon fontSize="medium" />
        </Box>

        <Typography variant="h6" sx={courseCompletionModalSx.titleText}>
          Course submitted!
        </Typography>

        <Typography sx={courseCompletionModalSx.bodyText}>
          You will be notified via email once it has been approved, typically within 48 hours.
        </Typography>

        <Button
          variant="contained"
          onClick={handleClose}
          fullWidth
        >
          Close
        </Button>
      </Box>
    </Modal>
  );
};

export default CourseCompletionModal;
